import Phaser from 'phaser';

export default class RandomValuePool {
  constructor(values) {
    this.values = Phaser.Utils.Objects.DeepCopy(values);
    this.restart();
  }

  restart () {
    this.pool = Phaser.Utils.Objects.DeepCopy(this.values);
    Phaser.Utils.Array.Shuffle(this.pool);
  }

  getValue () {
    if (this.pool.length <= 0) {
      this.restart();
    }
    return this.pool.pop();
  }
}